import React, { createContext, useContext, useState, useEffect } from "react";
import axiosInstance from "../api/axiosInstance";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Ao iniciar, verifica se há token e busca os detalhes do perfil do usuário
  useEffect(() => {
    axiosInstance
      .get("/user/profile")
      .then((res) => setUser(res))
      .catch(() => {
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  // Função de login
  const login = async (credentials) => {
    try {
      const res = await axiosInstance.post("/auth/login", credentials);
      if (res.message === "Login successful") {
        // Após login, obtenha o perfil do usuário
        const profileRes = await axiosInstance.get("/user/profile");
        setUser(profileRes);
        return profileRes;
      } else {
        throw new Error("Token inválido");
      }
    } catch (error) {
      throw error;
    }
  };

  // Função de registo
  const register = async (data) => {
    try {
      const res = await axiosInstance.post("/auth/register", data);
      return res;
    } catch (error) {
      throw error;
    }
  };

  // Função de logout
  const logout = async () => {
    try {
      await axiosInstance.post("/auth/logout");
      setUser(null);
    } catch (error) {
      console.error("Erro no logout:", error);
    } finally {
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider
      value={{ user, loading, login, register, logout, setUser }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
